<template>
    <div class="details-container" :class="{ 'show-comments': show }">
        <!-- Header -->
        <div class="header">
            <div class="inner-color">
                <img @click="back" class="back" :src="Back" alt="Back">  
                <h6 class="video-title">{{ response.Title }}</h6>

                <!-- Banner -->
                <div class="banner">
                    <img id="playBTN" class="play-btn" @click="play" :src="PlayBtn" alt="play">
                    <video id="video" class="banner-inner">
                        <source
                            v-if="response.File"
                            :src="URL + '/' + response.File" 
                            type="video/mp4"
                        >
                        Your browser does not support the video tag.
                    </video>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Back from '@/assets/images/courses/video-details/back.png';
import ShiningArrow from '@/assets/images/courses/video-details/shining-arrow.png';
import PlayBtn from '@/assets/images/btn-play.png';

import { getRequest, APP_API_URL } from '@/utils/libs/api-request';
import Cookies from 'js-cookie';

export default {
    name: 'BaseCourseDetails',
    beforeRouteEnter(to, from, next) {
        next(vm => {
            vm.prevRoute = from
        })
    },
    data() {
        return {
            Back: Back,
            PlayBtn: PlayBtn,
            ShiningArrow: ShiningArrow,

            prevRoute: {},
            show: false,

            response: {},
            URL: APP_API_URL(),

            videoId: this.$route.params.id,
        }
    },
    mounted() {
        this.getCurrent();
    },
    methods: {
        play() {
            let video = document.getElementById('video');
            let btn = document.getElementById('playBTN');
            
            btn.style.display = 'none';

            video.play();
            video.addEventListener('ended', () => {
                video.currentTime = 0;
                btn.style.display = 'inline-block';
            }, false);
        },
        getCurrent() {
            getRequest('/videos/find-one', { id: this.videoId })
                .then((rsp) => {
                    let data = rsp['data']
                    this.response = data;
                })
                .catch(err => {
                // check auth
                    if (err.response) {
                        if (err.response.status == 401) {
                            Cookies.remove('access_cookie');
                            this.$router.push({ name: 'Login' })
                        }
                    }
                });
        },
        back() {
            if(this.prevRoute.name) {
                this.$router.go(-1)
            } else {
                this.$router.push({ name: 'Khanesh' })
            }
        }
    }
}
</script>

<style scoped>
/* ---------------------------------------- */
/* ---------------- GENERAL --------------- */
/* ---------------------------------------- */
.details-container.show-comments {
    background-color: #373b48;
}
.details-container .show-btns {
    box-shadow: inset 1px 2px 5px 2px #cccccc82 !important;
    background-color: #f7f7f7 !important;
}
/* ---------------------------------------- */
/* ---------------- HEADER ---------------- */
/* ---------------------------------------- */
.details-container {
    min-height: 100vh;
    background-color: #f1f2f6;

    position: relative;
    overflow: hidden;
} 
.details-container .header {
    height: 95vh;
    width: 100vw;

    position: relative;
    overflow: hidden;

    color: #666;
}
.details-container .header .back {
    height: 5vh;

    position: absolute;
    top: 10pt;
    right: 10pt;

    cursor: pointer;
}
.details-container .header .video-title {
    position: absolute;
    top: calc(5pt + 1rem);
    right: 35pt;
}
.details-container .header .inner-color {
    height: 100%;
    width: 100%;
    padding: 45pt 15pt;

    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    background-color: #fff;

    border-bottom-left-radius: 50pt;
}
.details-container .header .col-6 {
    height: auto;
    padding: .125rem;
    padding-top: 15pt;

    display: flex;
}
.details-container .header p,
.details-container .header button {
    width: 95%;
    max-width: 200pt;
    margin: 0 auto auto;

    font-size: 1rem;
    text-align: center;
}
.details-container .header button {
    height: 35pt;
    border-radius: 17pt;
    border: 1pt solid #ddd;
    box-shadow: 2px 3px 5px 0 #ddd;
}
@media (max-width: 576px) {
    .details-container .header .video-title {
        top: calc(5pt + .75rem);
    }
    .details-container .header p,
    .details-container .header button {
        font-size: .75rem;
    }
}

/* ---------------------------------------- */
/* ------------- VIDEO BANNER ------------- */
/* ---------------------------------------- */
.details-container .header .banner {
    height: 75vh;
    width: 85%;
        
    margin: auto;
    margin-top: 5vh;
    padding: 5pt;

    position: relative;

    border: 2px solid #fff;
    border-radius: 20pt;
    background-color: #ebecf1;
    box-shadow: inset 2.2px 2.2px 4px #c3c5c7;
}
.details-container .header .banner .play-btn {
    height: 35pt;
    width: 35pt;

    position: absolute;
    top: calc(37.5vh - 20pt);
    left: calc(50% - 15pt);
    z-index: 4;

    cursor: pointer;
}
.details-container .header .banner .banner-inner {
    height: 100%;
    width: 99%;

    position: relative;
    display: flex;
    flex-direction: column;
    overflow: hidden;

    border-radius: 15pt;
    background-color: #000;
}
@media (max-width: 576px) {
    .details-container .header .banner {
        margin-top: 0;
    }
}

/* ---------------------------------------- */
/* ------------- VIDEO DETAILS ------------ */
/* ---------------------------------------- */
.details-container .blue-box {
    height: 50vh;

    position: absolute;
    bottom: -10vh;
    left: -10vh;
}
.details-container .shining-arrow {
    height: 40vh;

    position: absolute;
    bottom: -10pt;
    right: 10pt;
}
</style>